import {makeAutoObservable} from 'mobx'
import CodeObject from './CodeObject'
import Contact from './Contact'
import Association from './Association'
import Payment from './payment'
import Audit from './Audit'

export default class Institution {
  id: number

  name: string

  institutionHeadName?: string

  mail?: string

  statusId?: number

  status?: CodeObject | null

  contact?: Contact

  association?: Association

  phone?: string

  institutionHeadPhone?: string

  city?: string

  houseNumber?: string

  zipCode?: string

  street?: string

  createdAt?: Date

  updatedAt?: Date

  internalNote?: string

  externalNote?: string

  isAssociationBelongTo?: boolean

  payments?: Payment[]

  auditor?: string

  auditNote?: string

  audit?: Audit

  isUnhandleDuplicate?: boolean

  monthStatus?: number

  paymentCommentStatusId?: number

  stipendCalendarType?: number

  stipendPaymentDay?: number

  receivesDatotBudget?: boolean

  isFixedPayment?: boolean

  fixedPaymentAmount?: number

  constructor(institution: any, statusesCodes?: CodeObject[]) {
    this.id = institution.Id
    this.name = institution.Name
    this.institutionHeadName = institution.InstitutionHeadName
    this.mail = institution.Mail
    this.phone = institution.Phone
    this.statusId = institution.StatusId
    this.institutionHeadPhone = institution.institutionHeadPhone
    this.city = institution.City
    this.houseNumber = institution.HouseNumber
    this.zipCode = institution.ZipCode
    this.street = institution.Street
    this.createdAt = new Date(institution.CreatedAt)
    this.updatedAt = new Date(institution.UpdatedAt) || undefined
    this.internalNote = institution.InternalNote
    this.externalNote = institution.ExternalNote
    if (statusesCodes)
      this.status = this.findStatus(statusesCodes, institution.StatusId)
    this.contact = institution.Contact
      ? new Contact(institution.Contact)
      : undefined
    this.association = institution.Association
      ? new Association(institution.Association)
      : undefined
    this.isAssociationBelongTo = institution.IsAssociationBelongTo
    if (institution.Payments !== undefined && institution.Payments.length > 0) {
      this.payments = institution.Payments.map((o: any) => new Payment(o))
    }
    this.auditor = institution.Auditor

    this.auditNote = institution.AuditNote

    this.audit = new Audit({InstitutionId: institution.Id})

    this.isUnhandleDuplicate = institution.IsUnhandleDuplicate

    this.monthStatus = institution.MonthStatus

    this.paymentCommentStatusId = institution.PaymentCommentStatusId

    this.stipendCalendarType = institution.StipendCalendarType
    this.stipendPaymentDay = institution.StipendPaymentDay
    this.receivesDatotBudget = institution.ReceivesDatotBudget
    this.isFixedPayment = institution.IsFixedPayment
    this.fixedPaymentAmount = institution.FixedPaymentAmount

    makeAutoObservable(this)
  }

  private findStatus(
    statuses: CodeObject[],
    statusId?: number
  ): CodeObject | null {
    if (statusId === undefined || statusId === null) {
      return null
    }
    return statuses.find(status => status.id === statusId) || null
  }
}
